exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".uu5-bricks-text-corrector-error {\n  text-decoration: none;\n  position: relative;\n}\n.uu5-bricks-text-corrector-error::after {\n  content: '~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~';\n  position: absolute;\n  width: 100%;\n  left: 0;\n  overflow: hidden;\n  top: 35%;\n  letter-spacing: -0.2em;\n  color: red;\n}\n.uu5-bricks-text-corrector-highlight {\n  background-color: #5bc0de;\n  color: #fff;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./bricks/text-corrector.less
// module id = 277
// module chunks = 0